module.exports = __webpack_public_path__ + "img/the-vanishing-half.0fb3d904.png";